export default [
  {
    text: "المنظمات",
    value: "ngos",
    class: "Ngo",
  },
  {
    text: "المستخدمين",
    value: "users",
    class: "User",
  },
  {
    text: "تصنيفات المنظمات",
    value: "ngoClassifications",
    class: "NgoClassification",
  },
  {
    text: "الفروع",
    value: "branches",
    class: "Branch",
  },
  {
    text: "الخدمات",
    value: "services",
    class: "Service",
  },
  {
    text: "المراكز الخدمية",
    value: "serviceCentres",
    class: "ServiceCentre",
  },
  {
    text: "معلومات التواصل",
    value: "contacts",
    class: "ContactInformation",
  },
  {
    text: "الحسابات البنكية",
    value: "bankAccounts",
    class: "BankAccount",
  },
  {
    text: "محركي الحساب",
    value: "accountManagers",
    class: "AccountManager",
  },
  {
    text: "العقارات",
    value: "realEstates",
    class: "RealEstate",
  },
  {
    text: "الآليات",
    value: "machines",
    class: "Machine",
  },
  {
    text: "البرامج",
    value: "programs",
    class: "Program",
  },
  {
    text: "الأنشطة",
    value: "activities",
    class: "Activity",
  },
  {
    text: "الخطط السنوية",
    value: "plans",
    class: "Plan",
  },
  {
    text: "حملات التبرع",
    value: "campaigns",
    class: "Campaign",
  },
  {
    text: " الفعاليات ",
    value: "events",
    class: "Event",
  },
  //   {
  //     text: "المتطوعين",
  //     value: "volunteers",
  //   },
  //   {
  //     text: "مجلس الإدارة",
  //     value: "administrators",
  //   },
  //   {
  //     text: "مجلس التأسيس",
  //     value: "founders",
  //   },
  //   {
  //     text: "مجلس الأمناء",
  //     value: "trustees",
  //   },
  {
    text: "الموظفين",
    value: "employees",
    class: "Employee",
  },
  //   {
  //     text: "المجلس التنفيذي",
  //     value: "executives",
  //   },
  //   {
  //     text: "فرص العمل",
  //     value: "opp-jobs",
  //   },
  //   {
  //     text: "فرص التطوع",
  //     value: "opp-volunteer",
  //   },
  {
    text: "فرص المنظمة",
    value: "opportunities",
    class: "Opportunity",
  },
  {
    text: "أخبار المنظمة",
    value: "news",
    class: "News",
  },
];
